import React, { useState, useRef, useContext } from "react";
import { SettingsContext } from './AccountSettingsButton';
import { Tooltip, OverlayTrigger, Row, Col, Button, Table, Form } from "react-bootstrap";
import jsDig from "utils/jsDig.js";

export default function Inflation() {
  const props = useContext(SettingsContext);
  const section = "search";
  const platforms = ["Google", "Microsoft"]
  const csvUploadRef = useRef();
  const lodashClonedeep = require("lodash/cloneDeep");
  const [tempValue, setTempValue] = useState({});

  let document = require("images/lite/icons/document.png");
  document = (
    <img className="settings-icon" alt="document" src={`/datapulse${document}`} />
  );

  let transfer = require("images/lite/icons/transfer.png");
  transfer = (
    <img className="settings-icon" alt="transfer" src={`/datapulse${transfer}`} />
  );

  let paste = require("images/lite/icons/paste.png");
  paste = (
    <img className="settings-icon" alt="paste" src={`/datapulse${paste}`} />
  );

  let calendarBolt = require("images/lite/icons/calendarBolt.png");
  calendarBolt = (
    <img className="inflation-icon" alt="calendarBolt" src={`/datapulse${calendarBolt}`} />
  );
  

  const [selectedPlatform, setSelectedPlatform] = useState(platforms[0]);
  let yieldMetrics = ["Revenue", "Conversions"];
  const [inflation, setInflation] = useState(props.inflation);
  const copyInflation = () => {
    let copyInflationArray = { ...inflation };
    if (selectedPlatform === platforms[0]) {
      // using deep copy to avoid the object referencing another object but actually just copying the values
      copyInflationArray[`${selectedPlatform.toLowerCase()}`] = lodashClonedeep(inflation[`${platforms[1].toLowerCase()}`]);
    } else if (selectedPlatform === platforms[1]) {
      copyInflationArray[`${selectedPlatform.toLowerCase()}`] = lodashClonedeep(inflation[`${platforms[0].toLowerCase()}`]);
    }
    setInflation({ ...copyInflationArray });
    props.setInflation({ ...copyInflationArray });
  };

  const uploadCsv = (e) => {
    let fileInput = $(e.target).get(0);
    let yieldTable = $(`.${props.section}-${selectedPlatform.toLowerCase()}-yield-table`);
    let reader = new FileReader();
    var extension = fileInput.files[0].name.split('.').pop().toLowerCase() // file extension from input file
    var fileTypes = ['csv'];
    var isSuccess = fileTypes.indexOf(extension) > -1;
    if (isSuccess) {
      reader.readAsText(fileInput.files[0]);

      function processCsv(file, yieldTable) {
        let yields = file.replace(/[\r]+/g, "").split("\n");
        let tableColumns = yieldTable.find("tbody tr").first().children().length - 1;
        let currentRow = 0;
        let currentColumn = 0;
        let newInflation = { ...inflation };
        yieldTable.find("input").each(function (index) {
          if (typeof yields[currentRow] == "string") {
            let cellValue = yields[currentRow].split(",")[currentColumn];
            $(this).val(cellValue);            
            if (!newInflation[selectedPlatform.toLowerCase()]) {
              newInflation[selectedPlatform.toLowerCase()] = {};
            }
            if (!newInflation[selectedPlatform.toLowerCase()][yieldMetrics[currentColumn].toLowerCase()]) {
              newInflation[selectedPlatform.toLowerCase()][yieldMetrics[currentColumn].toLowerCase()] = {};
            }
            newInflation[selectedPlatform.toLowerCase()][yieldMetrics[currentColumn].toLowerCase()][currentRow + 1] = cellValue;
          }
          if ((index + 1) % tableColumns == 0) {
            currentRow++;
            currentColumn = 0;
          } else {
            currentColumn++;
          }
        });
        setInflation(newInflation);
      }
      

      reader.onload = function () {
        processCsv(reader.result, yieldTable);
      };
    }
  };

  const ComingSoonTooltip = () => {
    const renderTooltip = (refs) => (
      <Tooltip className="grow-tooltip" id="button-tooltip" {...refs}>
        <div>This feature is coming soon.</div>
      </Tooltip>
    );

    return (
      <OverlayTrigger overlay={renderTooltip}>
        <button type="button" className="button b-type-secondary b-size-small">
          {transfer}
          <p>Import from linked accounts</p>
        </button>
      </OverlayTrigger>
    );
  };

  return (
    <>
      <div className="lite-inflation-container">
        {platforms === "Facebook" ? (
          <>
            <Form.Control className="primary" size="md" as="select" style={{ width: "362px", paddingLeft: "20px" }}>
              <option>Facebook</option>
            </Form.Control>
          </>
        ) : (
          <>
          <div>
            <p className="inflation-heading">{calendarBolt} Inflation (past 30 days)</p>
          </div>
          <div>
            <p className="inflation-td-1">Show inflation for: </p>
          <div className="select-wrapper inflation-picker">
            <select
              onChange={(e) => {
                setSelectedPlatform(e.target.value);
              }}
              value={selectedPlatform}>
              {platforms.map((platform, index) => {
                return <option key={index}>{platform}</option>;
              })}
            </select>
              </div>
          </div>
          </>
        )}

        <input
          style={{ backgroundColor: "#3291C1", display: "none" }}
          className="py-1 m-2"
          type="file"
          accept=".csv"
          ref={csvUploadRef}
          onChange={(e) => {
            uploadCsv(e);
          }}
          onClick={(e) => {
            e.target.value = null;
          }}
        />
        <div className="inflation-buttons">
        <button type="button" className="button b-type-secondary b-size-small" onClick={() => csvUploadRef.current.click()}>
            {document}
            <p>Import from CSV</p>
        </button>
          {ComingSoonTooltip()}
          {platforms !== "Facebook" && (
                    <button type="button" className="button b-type-secondary b-size-small" onClick={copyInflation}>
                    {paste}
                    <p>Copy from {selectedPlatform == platforms[0] ? platforms[1] : platforms[0]}</p>
                </button>
          )}
        </div>

        <div className="inflation-table-container" style={{position:"relative"}}>
          {platforms.map((platform, index) => {
            const visability = platform == selectedPlatform ? "flex" : "none";
            return (
              <Row style={{ display: visability }} key={index}>
                {[0, 1].map((tableIndex) => {
                  return (
                    <Col className="no-padding" lg xl={5} key={tableIndex}>
                      <div className="table-responsive mt-3 inflation-table">
                        <Table className={`${props.section}-${platform.toLowerCase()}-yield-table`}>
                          <thead>
                            <tr>
                              <th style={{maxWidth: "130px"}}></th>
                              {yieldMetrics.map((metric, index) => {
                                return (
                                  <th key={index}>
                                    <span className="inflation-td-1">{metric}</span>
                                  </th>
                                );
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {[...Array(15)].map((blank, index) => {
                              const day = index + 1 + tableIndex * 15;
                              return (
                                <tr key={index}>
                                  <td
                                    className="inflation-td-1 text-right"
                                  >
                                    Day {day}
                                  </td>

                                  {yieldMetrics.map((metric, index) => {
                                    metric = metric.toLowerCase();
                                    const value = jsDig([`${metric}`], inflation[`${platform.toLowerCase()}`])
                                      ? inflation[`${platform.toLowerCase()}`][`${metric}`][day]
                                      : "";

                                    return (
                                      <td key={index}>
                                        <input
                                            className="inflation-input"
                                            value={tempValue[`${platform}-${metric}-${day}`] ?? value} // Show tempValue if editing, else show main value
                                            name={`inflation[${section}][${platform.toLowerCase()}][${metric}][${day}]`}
                                            placeholder=""
                                            onChange={(e) => {
                                              // Update temporary value while typing
                                              setTempValue({
                                                ...tempValue,
                                                [`${platform}-${metric}-${day}`]: e.target.value,
                                              });
                                            }}
                                            onBlur={(e) => {
                                              let newInflation = { ...inflation };
                                              const inputValue = e.target.value === "" ? "" : parseFloat(e.target.value) || 0;
                                            
                                              // Convert input to 0 if it's negative
                                              const sanitizedValue = inputValue < 0 ? 0 : inputValue;
                                            
                                              if (!newInflation[platform.toLowerCase()]) {
                                                newInflation[platform.toLowerCase()] = {};
                                              }
                                              if (!newInflation[platform.toLowerCase()][metric]) {
                                                newInflation[platform.toLowerCase()][metric] = {};
                                              }
                                              newInflation[platform.toLowerCase()][metric][day] = sanitizedValue;
                                            
                                              // Update the main inflation state and reset tempValue for this input
                                              setInflation(newInflation);
                                              setTempValue((prev) => ({
                                                ...prev,
                                                [`${platform}-${metric}-${day}`]: sanitizedValue,
                                              }));
                                            }}
                                                                                  
                                          />
                                      </td>
                                    );
                                  })}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  );
                })}
              </Row>
            );
          })}
          <p style={{fontStyle: "italic", fontSize: "10px", position: "absolute", top: "0px", left: "10px"}}>Negative values are not permitted</p>
        </div>
      </div>
    </>
  );
}
